var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0.703125C10.459 0.703125 0.703125 10.459 0.703125 22.5C0.703125 34.541 10.459 44.2969 22.5 44.2969C34.541 44.2969 44.2969 34.541 44.2969 22.5C44.2969 10.459 34.541 0.703125 22.5 0.703125ZM22.5 9.14062C26.7715 9.14062 30.2344 12.6035 30.2344 16.875C30.2344 21.1465 26.7715 24.6094 22.5 24.6094C18.2285 24.6094 14.7656 21.1465 14.7656 16.875C14.7656 12.6035 18.2285 9.14062 22.5 9.14062ZM22.5 39.375C17.3408 39.375 12.7178 37.0371 9.62402 33.3809C11.2764 30.2695 14.5107 28.125 18.2812 28.125C18.4922 28.125 18.7031 28.1602 18.9053 28.2217C20.0479 28.5908 21.2432 28.8281 22.5 28.8281C23.7568 28.8281 24.9609 28.5908 26.0947 28.2217C26.2969 28.1602 26.5078 28.125 26.7188 28.125C30.4893 28.125 33.7236 30.2695 35.376 33.3809C32.2822 37.0371 27.6592 39.375 22.5 39.375Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/default-user.f86a9574d70a1e147620e93ecf61096a.svg";
export { ForwardRef as ReactComponent };